import { AccountCategory } from './actions';
import { AccountState } from './reducer';

const selectSlice = (state: any): AccountState => state.AccountCategoryManager;

export const getAccountList = (state: any): AccountCategory[] =>
  selectSlice(state)?.list ?? [];

export const getAccountLoading = (state: any): boolean =>
  !!selectSlice(state)?.loading;

export const getAccountSaving = (state: any): boolean =>
  !!selectSlice(state)?.saving;

export const getFilterName = (state: any): string =>
  selectSlice(state)?.filterName ?? '';

export const getModalOpen = (state: any): boolean =>
  !!selectSlice(state)?.modalOpen;

export const getEditingItem = (state: any): AccountCategory | null =>
  selectSlice(state)?.editing ?? null;

export const getFilteredAccountList = (state: any): AccountCategory[] => {
  const list = getAccountList(state);
  const q = (getFilterName(state) || '').trim().toLowerCase();

  let data = list;
  if (q) data = data.filter((c) => c.name?.toLowerCase().includes(q));
  return [...data].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
};